import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getGruposService,
  getGrupoDetailService,
  syncGrupoPermisosService,
  getPermisosDisponiblesService,
  getUsuariosPermisosService,
  getUsuarioPermisoDetailService,
  syncUsuarioGruposService,
  syncUsuarioPermisosEspecialesService,
} from "../../services/rolesPermisos/rolesPermisos.service";

export const getGruposThunk = createAsyncThunk(
  "rolesPermisos/getGrupos",
  async (_, { rejectWithValue }) => {
    try {
      return await getGruposService();
    } catch (e) {
      return rejectWithValue(e.response?.data?.error || "Error al cargar grupos");
    }
  }
);

export const getGrupoDetailThunk = createAsyncThunk(
  "rolesPermisos/getGrupoDetail",
  async (id, { rejectWithValue }) => {
    try {
      return await getGrupoDetailService(id);
    } catch (e) {
      return rejectWithValue(e.response?.data?.error || "Error al cargar el grupo");
    }
  }
);

export const syncGrupoPermisosThunk = createAsyncThunk(
  "rolesPermisos/syncGrupoPermisos",
  async ({ id, permissionIds }, { rejectWithValue }) => {
    try {
      return await syncGrupoPermisosService(id, permissionIds);
    } catch (e) {
      return rejectWithValue(e.response?.data?.error || "Error al guardar permisos");
    }
  }
);

export const getPermisosDisponiblesThunk = createAsyncThunk(
  "rolesPermisos/getPermisosDisponibles",
  async (_, { rejectWithValue }) => {
    try {
      return await getPermisosDisponiblesService();
    } catch (e) {
      return rejectWithValue(e.response?.data?.error || "Error al cargar permisos");
    }
  }
);

export const getUsuariosPermisosThunk = createAsyncThunk(
  "rolesPermisos/getUsuarios",
  async (search, { rejectWithValue }) => {
    try {
      return await getUsuariosPermisosService(search);
    } catch (e) {
      return rejectWithValue(e.response?.data?.error || "Error al cargar usuarios");
    }
  }
);

export const getUsuarioPermisoDetailThunk = createAsyncThunk(
  "rolesPermisos/getUsuarioDetail",
  async (id, { rejectWithValue }) => {
    try {
      return await getUsuarioPermisoDetailService(id);
    } catch (e) {
      return rejectWithValue(e.response?.data?.error || "Error al cargar el usuario");
    }
  }
);

export const syncUsuarioGruposThunk = createAsyncThunk(
  "rolesPermisos/syncUsuarioGrupos",
  async ({ id, grupoIds }, { rejectWithValue }) => {
    try {
      return await syncUsuarioGruposService(id, grupoIds);
    } catch (e) {
      return rejectWithValue(e.response?.data?.error || "Error al guardar grupos del usuario");
    }
  }
);

export const syncUsuarioPermisosEspecialesThunk = createAsyncThunk(
  "rolesPermisos/syncUsuarioPermisosEspeciales",
  async ({ id, permisoIds }, { rejectWithValue }) => {
    try {
      return await syncUsuarioPermisosEspecialesService(id, permisoIds);
    } catch (e) {
      return rejectWithValue(
        e.response?.data?.error || "Error al guardar permisos especiales"
      );
    }
  }
);
